"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _reactI18next = require("react-i18next");
var _reactQrCode = _interopRequireDefault(require("react-qr-code"));
var _appContext = _interopRequireDefault(require("../../context/appContext"));
var _getInvitationToken = _interopRequireDefault(require("../../utils/getInvitationToken"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _core.makeStyles)(theme => ({
  root: {
    marginBottom: theme.spacing(5),
    marginTop: theme.spacing(2),
    textAlign: "center"
  },
  text: {
    lineHeight: 1.2,
    margin: theme.spacing(0, 0, 3)
  },
  qrCode: {
    display: "flex",
    justifyContent: "center",
    "& svg": {
      height: "auto",
      display: "block",
      maxWidth: 128,
      width: "100%"
    }
  }
}));
const UserInvitePersonQRCode = () => {
  var _customLinks$find$url, _customLinks$find;
  const [appData] = (0, _react.useContext)(_appContext.default);
  const {
    customLinks = []
  } = appData || {};
  const [token, setToken] = (0, _react.useState)();
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const css = useStyles();
  (0, _react.useEffect)(() => {
    const fetchData = async () => {
      const {
        token
      } = await (0, _getInvitationToken.default)();
      if (token) setToken(token);
    };
    fetchData();
  }, []);
  const formURL = (_customLinks$find$url = customLinks === null || customLinks === void 0 || (_customLinks$find = customLinks.find(_ref => {
    let {
      identifier
    } = _ref;
    return identifier === "user-invite-person-qr-code";
  })) === null || _customLinks$find === void 0 ? void 0 : _customLinks$find.url) !== null && _customLinks$find$url !== void 0 ? _customLinks$find$url : "/";
  if (!token) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: css.root
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h2"
  }, t("site.userInvitePersonQRCode.headline")), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: css.text,
    variant: "body2"
  }, t("site.userInvitePersonQRCode.text")), /*#__PURE__*/_react.default.createElement("div", {
    className: css.qrCode
  }, /*#__PURE__*/_react.default.createElement(_reactQrCode.default, {
    value: "".concat(formURL, "?token=").concat(token)
  })));
};
var _default = exports.default = UserInvitePersonQRCode;